import { Box, FormControl, FormHelperText, IconButton, TextField, Typography } from "@mui/material";
import { isTablet } from "react-device-detect";
import { isNullOrEmpty } from "../common/common";
import "../styles/components/textfield.css";

interface textfieldProps {
  placeholder?: string;
  value?: string;
  onChange?: any;
  leadIcon?: any;
  trailIcon?: any;
  trailIconCallback?: any;
  autoComplete?: string;
  fullWidth?: boolean;
  error?: boolean;
  errorMessage?: string;
  helperMessage?: string;
  maxLength?: number;
  showCharacterCount?: boolean;
  multiline?: boolean;
  defaultValue?: string;
  rows?: number;
}
export const TextFieldOutlinedComponent = ({ placeholder, value = "", onChange, leadIcon, trailIcon, trailIconCallback, autoComplete = "off", fullWidth = false, error = false, errorMessage = "", helperMessage = "", maxLength, showCharacterCount = false, multiline = false, defaultValue = "", rows = 1 }: textfieldProps) => {
  return (
    <FormControl error={error} fullWidth sx={{ height: !multiline ? (isTablet ? "56px" : "48px") : "unset" }}>
      <TextField
        placeholder={placeholder}
        variant="outlined"
        value={value}
        onChange={(e: any) => {
          onChange && onChange(e);
        }}
        autoComplete={autoComplete}
        fullWidth={fullWidth}
        multiline={multiline}
        defaultValue={defaultValue}
        rows={rows}
        error={error}
        sx={{
          height: !multiline ? (isTablet ? "56px" : "48px") : "unset",
          width: "100%",
        }}
        inputProps={{
          maxLength: maxLength ? maxLength : null,
          style: { flex: 1, height: !multiline ? (isTablet ? "56px" : "48px") : "unset", padding: multiline ? "12px 8px" : "0 8px" },
        }}
        InputProps={{
          sx: { padding: "0 16px 0 8px" },
          startAdornment: leadIcon,
          endAdornment: trailIcon && (
            <IconButton
              disabled={isNullOrEmpty(trailIconCallback)}
              className="mar-l-8 box-48 MuiInputBase-trailIcon"
              onClick={(e) => {
                trailIconCallback && trailIconCallback(e);
              }}
            >
              {trailIcon}
            </IconButton>
          ),
        }}
      />
      {(error && errorMessage) || helperMessage || (showCharacterCount && maxLength) ? (
        <FormHelperText component={"div"}>
          <Box className="mar-t-5 flex flex-space-between bbcbc">
            <Box className="display-flex-center">
              {error && errorMessage ? (
                <>
                  <span className={`material-symbols-rounded icon-mild-crimson size-16 mar-r-8`}>error</span>
                  <Typography className="text-crimson ht-16" variant="caption">
                    {errorMessage}
                  </Typography>
                </>
              ) : helperMessage ? (
                <>
                  <span className={`material-symbols-rounded icon-neutral-gray size-16 mar-r-8`}>info</span>
                  <Typography className="text-secondary ht-16" variant="caption">
                    {helperMessage}
                  </Typography>
                </>
              ) : (
                <></>
              )}
            </Box>

            {showCharacterCount && !error && maxLength ? (
              <Box className="flex">
                <span className={`material-symbols-rounded icon-neutral-gray size-16 mar-r-8`}>text_fields</span>
                <Typography className="text-secondary ht-16" variant="caption">
                  Character count: {`${value?.length} / ${maxLength}`}
                </Typography>
              </Box>
            ) : (
              <></>
            )}
          </Box>
        </FormHelperText>
      ) : (
        <></>
      )}
    </FormControl>
  );
};
